module.exports = __webpack_public_path__ + "media/images/products/retailers-ecommerce-4-sample03-81f8e0ba511a5d9f4f7c4d74b783b2ae.jpg";